// ============================================================================
// BonBoZ: gán mẫu trả lời cho nhiều trang một lúc.
//
// Gán theo kiểu THÊM VÀO: trang đang có 5 mẫu, gán thêm 3 thành 8. Không bao
// giờ gỡ mẫu cũ — người bấm "gán 3 mẫu này" không hình dung được là mình vừa
// gỡ 5 mẫu khác khỏi trang. Muốn gỡ thì vào màn "Gán theo trang", ở đó nhìn
// thấy rõ mình đang bỏ tick cái gì.
//
// Không có endpoint gán hàng loạt: PATCH từng trang, mỗi trang một lượt. Với
// mươi trang thì không đáng làm thêm API.
// ponytail: tuần tự; chuyển sang gọi song song nếu số trang lên hàng trăm.
// ============================================================================
import PageConfigsAPI, { loiApi } from 'dashboard/api/pageConfigs';
import { idMauCuaTrang, setPageConfig } from 'dashboard/helper/pageConfig';

/**
 * @param {number[]} inboxIds trang được chọn
 * @param {number[]} mauIds   mẫu cần gán
 * @returns {{ xong: number, loi: string }} `loi` rỗng nghĩa là mọi trang đều ổn
 */
export const ganMauChoTrang = async (inboxIds, mauIds) => {
  let xong = 0;
  let loi = '';
  for (let i = 0; i < inboxIds.length; i += 1) {
    const inboxId = inboxIds[i];
    // Hợp với danh sách đang có của CHÍNH trang đó, không phải danh sách chung.
    const gop = new Set([...idMauCuaTrang(inboxId)].map(Number));
    mauIds.forEach(id => gop.add(Number(id)));
    try {
      // eslint-disable-next-line no-await-in-loop
      const { data } = await PageConfigsAPI.update(inboxId, {
        canned_response_ids: [...gop],
      });
      setPageConfig(inboxId, data);
      xong += 1;
    } catch (e) {
      loi = loiApi(e);
    }
  }
  return { xong, loi };
};
